<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconFlipCamera_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M19.5 6h-2.25l-1.085-2.171A1.5 1.5 0 0 0 14.823 3H9.177a1.5 1.5 0 0 0-1.342.829L6.75 6H4.5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3ZM6.352 16.201 3.7 13.55a.563.563 0 0 1 .648-.902l1.653.821A6.006 6.006 0 0 1 12 7.5c1.389 0 2.664.48 3.68 1.278.366.287.358.847.002 1.146a.736.736 0 0 1-.928.021A4.477 4.477 0 0 0 12 9a4.504 4.504 0 0 0-4.497 4.467l1.648-.819a.563.563 0 0 1 .648.902l-2.652 2.651a.562.562 0 0 1-.795 0Zm14.006-2.025a.564.564 0 0 1-.707.176l-1.653-.821A6.005 6.005 0 0 1 12 19.5a5.936 5.936 0 0 1-3.68-1.278c-.365-.287-.358-.847-.002-1.146a.736.736 0 0 1 .928-.021A4.477 4.477 0 0 0 12 18a4.504 4.504 0 0 0 4.497-4.467l-1.648.819a.563.563 0 0 1-.648-.902l2.652-2.651c.22-.22.576-.22.796 0L20.3 13.45a.562.562 0 0 1 .058.726Z"
    />
</svg>
